<script>
  export let title = null
  import { cssPrefix } from '../helper-classes.js'
</script>

<div class={`${cssPrefix}inspector-section`}>
  {#if title}
    <b class={`${cssPrefix}inspector-section-title`}>{title}</b>
    <div class={`${cssPrefix}horizontal-line my-2`} />
  {/if}
  <slot />
</div>
